export default __webpack_public_path__ + "static/media/gxbank-color.b86e9904.svg";